import React, { Component } from 'react';
import Start_Date from './Components/Start_Date';
import Energy_Categories from './Components/Energy_Categories';
import Water_Categories from './Components/Water_Categories';
import Top_Bar from '../../Part_Sample/Top_Bar';
import { isEmpty } from '../../Common/Common';

import { navigateReport } from '../../Common/navigation';

export default class Report_Settings extends Component {
	constructor(props) {
		super(props);

		let report_settings = {
			"start_month": 0,
			"start_day": 1,
			"categories": {
				"is_show_energy_categories": false,
				"is_energy_generator_enabled": false,
				"is_water_consumption_enabled": false,
				"is_recycled_water_enabled": false,
				"energy": {},
				"energy_generator": {
					"name": "energy_generator",
					"points": []
				},
				"water_consumption": {
					"name": "water_consumption",
					"points": []
				},
				"recycled_water": {
					"name": "recycled_water",
					"points": []
				}
			}
		}

		if (!isEmpty(this.props.param.report_settings)) {
			report_settings = JSON.parse(JSON.stringify(this.props.param.report_settings));
			// For display collapsible
			if (!isEmpty(report_settings.categories)) {
				let energy = report_settings.categories.energy;
				for (let category_id in energy) {
					energy[category_id].is_show_points = false;
				}
				report_settings.categories.energy = energy;
			}
		}

		this.state = {
			report_settings: report_settings,
		}
	}

	handlePrevious = () => {
		// Go back to previous screen
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		navigateReport("null");
	}

	handleModifyCategories = (report_settings) => {
		this.setState({
			report_settings: report_settings
		})
	}

	/*
	 * Saving
	 */

	handleRegister = () => {
		let report_settings = this.state.report_settings;
		let energy = JSON.parse(JSON.stringify(report_settings.categories.energy));
		let check_name = [];
		for (let category_id in energy) {
			if (energy[category_id].name == '') {
				window.app.showToast(this.props.receiver.getString('no_name'), 3000);
				return;
			}
			// Check if category name already exists
			if (!check_name.includes(energy[category_id].name)) {
				check_name.push(energy[category_id].name);
			} else {
				window.app.showToast(this.props.receiver.getString('name_already_exists'), 3000);
				return;
			}
			// For display collapsible, delete this before saving
			delete energy[category_id].is_show_points;
		}

		report_settings.categories.energy = energy;
		window.app.showLoading();
		this.props.receiver.saveReportSettings(report_settings);
	}

	rcvSaveReportSettings = (data) => {
		window.app.hideLoading();
		if (data.result == 'OK') {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			navigateReport("null");
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			overflow: 'auto'
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('report_settings')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ paddingTop: 20, paddingBottom: 20, marginTop: -20, height: this.props.height - 140, overflow: 'auto' }}>
						<Start_Date
							report_settings={this.state.report_settings}
							handleModifyCategories={this.handleModifyCategories}
							receiver={this.props.receiver}
							width={this.props.width}
							height={this.props.height}
						/>
						<Energy_Categories
							report_settings={this.state.report_settings}
							handleModifyCategories={this.handleModifyCategories}
							receiver={this.props.receiver}
							width={this.props.width}
							height={this.props.height}
						/>
						<Water_Categories
							report_settings={this.state.report_settings}
							handleModifyCategories={this.handleModifyCategories}
							receiver={this.props.receiver}
							width={this.props.width}
							height={this.props.height}
						/>
					</div>
				</div>
			</div>
		)
	}
}